import jwtDecode from "jwt-decode";
import http from "./httpService";
import configdata from "./config.json";
const tokenKey = "token";
let apiEndpoint = "";
if (process.env.NODE_ENV !== "production") {
  apiEndpoint = `${configdata.apiUrl}/auth`;
} else {
  apiEndpoint = `${configdata.herokuUrl}/auth`;
}
export async function login(user) {
  const data = await http.post(apiEndpoint, user);
  console.log(data);
  sessionStorage.setItem("token", data.token);
  return data;
}

export async function loginWithFaceBook() {
  const { data } = await http.get(`${apiEndpoint}/facebook`);
  sessionStorage.setItem(tokenKey, data.token);
  http.setJwt(data.token);
  return data;
}

export async function loginWithGoogle() {
  const { data } = await http.get(`${apiEndpoint}/auth/google`);
  sessionStorage.setItem(tokenKey, data.token);
  http.setJwt(data.token);
  return data;
}

export function loginWithJwt(jwt) {
  localStorage.setItem("token", jwt);
}

export function logout() {
  sessionStorage.removeItem("token");
}

export function getJwt() {
  return sessionStorage.getItem("token");
}

export function getCurrentUser() {
  try {
    const jwt = sessionStorage.getItem("token") ? sessionStorage.getItem("token") : localStorage.getItem("token");
    return jwtDecode(jwt);
  } catch (ex) {
    return null;
  }
}






export async function forgotpasssword(email) {
  const data = await http.post(`${apiEndpoint}/forgotpasssword`, email);
  return data;
}







export async function resetPassword(user) {
  const data = await http.post(`${apiEndpoint}/resetpassword`, user);
  return data;
}

export async function sendOtp(param) {
  const data = await http.post(`${apiEndpoint}/sendOtp`, param);
  return data;
}

export async function verifyOtp(param) {
  const data = await http.post(`${apiEndpoint}/verifyOtp`, param);
  return data;
}

export async function sendOtpForLogin(param) {
  const data = await http.post(`${apiEndpoint}/sendOtpForLogin`, param);
  return data;
}

export async function verifyOtpForLogin(param) {
  const data = await http.post(`${apiEndpoint}/verifyOtpForLogin`, param);
  return data;
}

export async function checkOtpStatus(param) {
  const data = await http.post(`${apiEndpoint}/checkOtpStatus`, param);
  return data;
}




export default {
  login,
  loginWithJwt,
  logout,
  getCurrentUser,
  getJwt,
  resetPassword,
  loginWithFaceBook,
  loginWithGoogle,
  forgotpasssword,
  sendOtp,
  verifyOtp,
  sendOtpForLogin,
  verifyOtpForLogin
};
